import React from 'react';

interface ReviewSummaryProps {
  title?: string;
  description?: string;
  titleEN?: string;
  descriptionEN?: string;
  tags: { tag: string }[];
  tagsEN: { tag: string }[];
  hasImage: boolean;
  image: File | null;
  imageEN: File | null;
  audienceLabel?: string;
}

const ReviewSummary: React.FC<ReviewSummaryProps> = ({
  title,
  description,
  titleEN,
  descriptionEN,
  tags,
  tagsEN,
  hasImage,
  image,
  imageEN,
  audienceLabel,
}) => (
  <div className="flex flex-col gap-4 bg-gray-50 border border-gray-200 rounded-lg p-4">
    <div>
      <h3 className="font-semibold text-gray-700">Español</h3>
      <p className="text-sm text-gray-900">{title}</p>
      <p className="text-sm text-gray-500">{description}</p>
    </div>
    <div>
      <h3 className="font-semibold text-gray-700">English</h3>
      <p className="text-sm text-gray-900">{titleEN}</p>
      <p className="text-sm text-gray-500">{descriptionEN}</p>
    </div>
    {audienceLabel && (
      <div>
        <h3 className="font-semibold text-gray-700">Audiencia</h3>
        <p className="text-sm text-gray-900">{audienceLabel}</p>
      </div>
    )}
    {hasImage && (
      <div className="text-sm text-gray-700">
        <p>Imagen (ES): {image ? 'adjuntada' : 'sin adjuntar'}</p>
        <p>Imagen (EN): {imageEN ? 'adjuntada' : 'sin adjuntar'}</p>
      </div>
    )}
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <span
          key={`es-${tag.tag}`}
          className="text-xs bg-gray-500 text-white px-2 py-1 rounded-md"
        >
          {tag.tag}
        </span>
      ))}
      {tagsEN.map((tag) => (
        <span
          key={`en-${tag.tag}`}
          className="text-xs bg-gray-400 text-white px-2 py-1 rounded-md"
        >
          {tag.tag}
        </span>
      ))}
    </div>
  </div>
);

export default ReviewSummary;
